import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgBankIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M27 13.231H5a1 1 0 0 1-1-1v-2.052a1 1 0 0 1 .58-.908l11-5.077a1 1 0 0 1 .84 0l11 5.077a1 1 0 0 1 .58.907v2.053a1 1 0 0 1-1 1M8 15H6v9h2zm4 0h2v9h-2zm8 0h-2v9h2zm8 11v2H4v-2zm-2-11h-2v9h2z"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgBankIcon;
